import { render } from "./lesson4modal2.vue?vue&type=template&id=3a767dbe"
import script from "./lesson4modal2.vue?vue&type=script&lang=js"
export * from "./lesson4modal2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__